import { sortBy } from 'lodash';

export const combinators = [
  { name: 'AND', label: 'All' },
  { name: 'OR', label: 'Any' },
];

export const OPERATOR_NAME = {
  empty: 'EMPTY',
  notEmpty: 'NOT_EMPTY',
  contains: 'CONTAINS',
  notContains: 'NOT_CONTAINS',
  equals: 'EQUALS',
  notEquals: 'NOT_EQUALS',
  anyOf: 'ANY_OF',
  noneOf: 'NONE_OF',
  between: 'BETWEEN',
  dateEquals: 'DATE_EQUALS',
  dateNotEquals: 'DATE_NOT_EQUALS',
  dateBefore: 'DATE_BEFORE',
  dateAfter: 'DATE_AFTER',
  notBetween: 'NOT_BETWEEN',
};

export const textOperators = sortBy(
  [
    { name: OPERATOR_NAME.empty, label: 'Is empty', color: '#d8d8d8' },
    { name: OPERATOR_NAME.notEmpty, label: 'Is not empty', color: '#1b6064' },
    { name: OPERATOR_NAME.contains, label: 'Contains', color: '#9ec771' },
    { name: OPERATOR_NAME.notContains, label: 'Does not contain', color: '#a75187' },
    { name: OPERATOR_NAME.equals, label: 'Is', color: '#599b78' },
    { name: OPERATOR_NAME.notEquals, label: 'Is not', color: '#8c4c92' },
  ],
  'label',
);

export const dropDownOperators = sortBy(
  [
    { name: OPERATOR_NAME.empty, label: 'Is empty', color: '#d8d8d8' },
    { name: OPERATOR_NAME.notEmpty, label: 'Is not empty', color: '#1b6064' },
    { name: OPERATOR_NAME.equals, label: 'Is', color: '#599b78' },
    { name: OPERATOR_NAME.notEquals, label: 'Is not', color: '#8c4c92' },
    { name: OPERATOR_NAME.anyOf, label: 'Any of', color: '#718fc4' },
    { name: OPERATOR_NAME.noneOf, label: 'None of', color: '#67224d' },
  ],
  'label',
);

export const datesOperators = sortBy(
  [
    { name: OPERATOR_NAME.empty, label: 'Is empty', color: '#d8d8d8' },
    { name: OPERATOR_NAME.notEmpty, label: 'Is not empty', color: '#1b6064' },
    { name: OPERATOR_NAME.dateEquals, label: 'Is', color: '#599b78' },
    { name: OPERATOR_NAME.dateNotEquals, label: 'Is not', color: '#8c4c92' },
    { name: OPERATOR_NAME.dateBefore, label: 'Is before', color: '#fdc86b' },
    { name: OPERATOR_NAME.dateAfter, label: 'Is after', color: '#71bcc4' },
    { name: OPERATOR_NAME.between, label: 'Is in the range (from-to)', color: '#71c498' },
    { name: OPERATOR_NAME.notBetween, label: 'Is not in the range (from-to)', color: '#e69497' },
  ],
  'label',
);

export const operatorNameToLabel = [...textOperators, ...dropDownOperators, ...datesOperators].reduce((acc, { name, label }) => {
  acc[name] = label;

  return acc;
}, {});

export const operatorsByType = {
  autocomplete: textOperators,
  text: textOperators,
  chargerPackage: textOperators,
  select: dropDownOperators,
  date: datesOperators,
};

export const defaultOperatorByType = {
  autocomplete: OPERATOR_NAME.contains,
  text: OPERATOR_NAME.contains,
  chargerPackage: { name: OPERATOR_NAME.contains, version: OPERATOR_NAME.notEmpty },
  select: OPERATOR_NAME.equals,
  date: OPERATOR_NAME.dateEquals,
};

export const emptyQuery = {
  id: 'g-query-root',
  combinator: 'AND',
  rules: [],
};

export const CONFIGURATIONS_FIELD_NAME = {
  nodeName: 'config_node_name',
  parameterName: 'parameter_name',
  valueName: 'parameter_value',
};

export const levelsColors = ['rgb(253, 196, 97)', 'rgb(114, 188, 196)', 'rgb(114, 143, 195)'];
